import classNames from "classnames";
import React, { ReactElement } from "react";

export interface AppSliderHandlerProps {
  direction: "start" | "end";
  disabled?: boolean;
  children?: React.ReactNode;
}

export function AppSliderHandler(props: AppSliderHandlerProps): ReactElement {
  return (
    <div
      className={classNames({
        AppSliderHandler: true,
        Disabled: props.disabled === true,
      })}
      data-direction={props.direction}
    >
      {props.children}
    </div>
  );
}
